
import { axios, BaseApiUrl} from '../axios_config';


//查询收货信息
export const getBatchGoodAsync = params => {
    return axios.get(`${BaseApiUrl}/BatchGood/GetBatchGoodAsync`, { params: params });
};

//查询收货箱唛信息
export const getBatchGoodDetailAsync = params => {
    return axios.get(`${BaseApiUrl}/BatchGood/GetBatchGoodDetailAsync`, { params: params });
};

//签收
export const insertAccordingSignFor = params => {
    return axios.post(`${BaseApiUrl}/BatchGood/InsertAccordingSignFor`, params);
};



//查询上架状态
export const getPutOnStatus = params => {
    return axios.get(`${BaseApiUrl}/BatchGood/GetPutOnStatus`, { params: params });
};


//查询上架信息
export const getShelvesManagementAsync = params => {
    return axios.post(`${BaseApiUrl}/BatchGood/GetShelvesManagementAsync`, params);
};


//导出
export const exportShelvesManagementOut = `${BaseApiUrl}/BatchGood/ShelvesManagementOut`;

//上架
export const submitPutStockBox = params => {
    return axios.post(`${BaseApiUrl}/PutOn/SubmitPutStockBox`, params);
};
